import { render, staticRenderFns } from "./TheSettingsUsers.vue?vue&type=template&id=58036f3a&"
import script from "./TheSettingsUsers.vue?vue&type=script&lang=js&"
export * from "./TheSettingsUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports